<template>
    <div class="toolbox-header">
        <button class="btn-icon icon-close" @click="closeToolbox" :disabled="loading"></button>
        <h2>Veröffentlichen bei Immoscout</h2>
        <div class="subheader">
            <div class="entry" v-for="categoryId in getExceededLimits" :key="categoryId">
                <div class="error-chip">Limit zum Veröffentlichen ({{ item.limitsByCategory[categoryId] }}) für {{ getCategoryName(categoryId).label }} wird überschritten</div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      closeToolbox () {
        this.$emit('close')
      }
    },
    computed: {
      getExceededLimits () {
        let exceeded = []
        for (let categoryId in this.item.currentObjectsByCategory) {
          if (this.item.currentObjectsByCategory[categoryId] > this.item.limitsByCategory[categoryId]) {
            exceeded.push(categoryId)
          }
        }

        return exceeded
      },
      getCategoryName () {
        return (categoryId) => {
          return this.item.objects[0].field_objectRights.options.find((item) => item.value == categoryId)
        }
      }
    }
  }
</script>

<style scoped>

</style>
